import { render, staticRenderFns } from "./Finition.vue?vue&type=template&id=aaff3306&"
import script from "./Finition.vue?vue&type=script&lang=js&"
export * from "./Finition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports